export const TAG_QUERY_FETCH = 'TAG/QUERY/FETCH';
export const TAG_QUERY_FETCH_SUCCESS = 'TAG/QUERY/FETCH/SUCCESS';
export const TAG_QUERY_FETCH_FAILURE = 'TAG/QUERY/FETCH/FAILURE';

export const TAG_TOGGLE = 'TAG/TOGGLE';
export const TAG_ALL_FETCH = 'TAG/ALL/FETCH';
export const TAG_ALL_FETCH_SUCCESS = 'TAG/ALL/FETCH/SUCCESS';
//internal action from saga only
export const TOGGLE_TAG = 'TOGGLE_TAG';

const initialState = {
  fullList: [],
  currentTags: [],
  queryTags: [],
  showMore: false,
};

export const fetchTagsByQuery = query => ({
  type: TAG_QUERY_FETCH,
  payload: { query },
});

export const fetchAllTags = () => ({
  type: TAG_ALL_FETCH,
});

export const toggleTag = (tag, type) => ({
  type: TAG_TOGGLE,
  payload: { tag, type },
});

export const bookletTagsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TAG_QUERY_FETCH_SUCCESS: {
      return { ...state, queryTags: [...payload.data] };
    }
    case TAG_ALL_FETCH_SUCCESS: {
      return { ...state, fullList: [...payload.data] };
    }
    case TOGGLE_TAG: {
      let newTags = [];
      if (payload.tag === null) {
        //clear list
      } else if (state.currentTags.indexOf(payload.tag) !== -1) {
        newTags = state.currentTags.filter(tag => tag !== payload.tag);
      } else {
        newTags = [...state.currentTags, payload.tag];
      }

      return { ...state, currentTags: [...newTags] };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/booklet-tags.reducer.js